// @flow
import WeatherDataExpiration from './WeatherDataExpiration';

export default WeatherDataExpiration;